<template>
  <div class="page-Dashb bg--blue mobile_only contact-page">
    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>
    <div class="Dashb-inner">
      <div class="page-Dashb-head center bg--white">
        <img class="logo-myMedical" src="assets/img/svg/logo-myMedical.svg" />
        <h2 class="title tx--blue">
          היי {{ activeDoctor.name }}, איך אוכל לעזור?
        </h2>
      </div>
      <div class="page-Dashb-main flex flex--top center bg--blue">
        <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/dashboard"
        >
          ניהול מרפאה
        </router-link>
        <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/dashboard/surgeries"
        >
          ניתוחים
        </router-link>
        <router-link
          class="dashb-box tx--blue flex flex--content--center relative"
          to="/table/pathology"
        >
          <span>
            <Bell class="pathology-bell" />
            <div class="pathology-dot" v-if="hasUnwatchedPathology"></div>
          </span>
          דוחות פתולוגיה
        </router-link>
        <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/surg-add-block"
        >
          הזמנת בלוק<br />
          ניתוחים
        </router-link>
        <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/table/surgery"
        >
          רשימת<br />
          ניתוחים/פעולות
        </router-link>
        <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/table/appointment"
        >
          רשימת<br />
          תורי מרפאה
        </router-link>
        <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/messages"
        >
          ההודעות<br />
          שלי
        </router-link>
        <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/contact"
        >
          יצירת<br />
          קשר
        </router-link>
        <!-- <router-link
          class="dashb-box tx--blue flex flex--content--center"
          to="/profile"
        >
          פרופיל<br />
          רופא
        </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import Bell from "../assets/img/svg/bell-blue.svg";
import { getInitPopup } from "../utilities/get-init-popup";
import { mapGetters } from "vuex";

export default {
  name: "Lobby",
  components: { DashboardHeader, Menu, Bell },
  computed: {
    ...mapGetters(["MENU_ACTIVE", "activeDoctor", "hasUnwatchedPathology"])
  }
  // mounted() {
  //   setTimeout(() => {
  //     const { key, popup, args } = getInitPopup(false);
  //     const afterLogin = localStorage.getItem(key);
  //     if (!afterLogin) {
  //       localStorage.setItem(key, true);
  //       this.$modal.show(popup, { step: "init-mobile" });
  //     }
  //   }, 500);
  // }
};
</script>

<style scoped>
.pathology-bell {
  position: absolute;
  top: 10px;
  left: 10px;
}
.pathology-dot {
  position: absolute;
  background-color: rgb(244, 74, 74);
  border-radius: 50%;
  top: 7px;
  left: 10px;
  width: 10px;
  height: 10px;
}
</style>
